class Modal {
    #ANIMATION_DURATION = 250;
    static #closedEvent = new Event('closed');
    static #openedEvent = new Event('opened');

    #modalElement;
    #onWindowKeyupListener = ['keyup', (event) => this.#onWindowKeyup(event), { capture: true }];

    constructor(htmlContent, options) {
        const defaultOptions = {
            invertedButton: false,
            initialHeight: '',
            fullSize: false
        };
        options = { ...defaultOptions, ...options };
        const template = document.createElement('template');
        const modal = `
            <div class="modal">
                <div class="modal-content container mx-auto${options.fullSize ? ' full-size' : ''}">
                    <button class="close-button${options.invertedButton ? ' inverted' : ''}" aria-label="Luk modal" title="Luk modal" tabindex="3">
                        <i class="icon icon-close"></i>
                    </button>
                    ${htmlContent}
                </div>
                <div class="overlay"></div>
            </div>
        `;
        template.innerHTML = modal;

        this.#modalElement = template.content.firstElementChild;
        const modalContent = this.#modalElement.querySelector('.modal-content');
        this.#setMaxHeight(options.initialHeight);

        const closeButton = modalContent.querySelector('.close-button');
        const overlay = this.#modalElement.querySelector('.overlay');

        template.remove();

        document.body.appendChild(this.#modalElement);

        overlay.addEventListener('click', () => this.hide());
        closeButton.addEventListener('click', () => this.hide());

        window.addEventListener.apply(window, this.#onWindowKeyupListener);
    }

    show() {
        this.#disableViewportScroll();

        afterNextDomRepaint()
            .then(() => {
                // Wait until the element is painted in the dom (after construction) and then show it
                // Otherwise the css transition won't work
                this.#modalElement.classList.add('show');
            });

        return new Promise(resolve => {
            setTimeout(() => {
                this.#emit(Modal.#openedEvent);
                resolve();
            }, this.#ANIMATION_DURATION);
        });
    }

    hide(supressEvent) {
        this.#modalElement.classList.remove('show');
        window.removeEventListener.apply(window, this.#onWindowKeyupListener);

        return new Promise(resolve => {
            setTimeout(() => {
                if (!supressEvent) {
                    this.#emit(Modal.#closedEvent);
                }

                this.#modalElement.remove();
                this.#enableViewportScroll();
                resolve();
            }, this.#ANIMATION_DURATION);
        });
    }

    expand() {
        this.#setMaxHeight('100%');
    }

    on = (eventName, func) => {
        this.#modalElement.addEventListener(eventName, func);
        return this;
    }

    #emit = (event) => {
        this.#modalElement.dispatchEvent(event);
    }

    #disableViewportScroll() {
        document.body.style.overflow = 'hidden';
    }

    #enableViewportScroll() {
        document.body.style.overflow = '';
    }

    #setMaxHeight(newValue) {
        if (!window.matchMedia('(min-width: 768px)').matches) {
            return;
        }

        this.#modalElement.querySelector('.modal-content').style.maxHeight = newValue;
    }

    #onWindowKeyup(event) {
        if (event.defaultPrevented) {
            return; // Do nothing if the event was already processed
        }

        if (event.key === "Escape" || event.key === "Esc") {
            this.hide();
        }

        // Cancel the default action to avoid it being handled twice
        event.preventDefault();
    }

    static error(errorMessage) {
        const errorContent = `
            <div class="error">
                <h2>Fejl<h2>
                <p>${errorMessage}</p>
            </div>
        `;

        return new this(errorContent);
    }
}
